import {autoserializeAs, autoserializeAsArray} from "dcerialize";
import {TeamMemberImages} from "./TeamMemberImages";

export enum TeamMemberGender {
  Unspecified = "unspecified",
  Male = "male",
  Female = "female",
}

export class TeamMember {
  @autoserializeAs(() => Number)
  public readonly id: number;
  @autoserializeAs(() => String)
  public readonly name: string;
  @autoserializeAs(() => String)
  public readonly gender: TeamMemberGender;
  @autoserializeAs(() => String)
  public readonly introduction: string;
  @autoserializeAs(() => TeamMemberImages)
  public readonly images?: TeamMemberImages;
  @autoserializeAsArray(() => String)
  public readonly roles: readonly string[];
  @autoserializeAs(() => Date)
  public readonly createdAt: Date;
  @autoserializeAs(() => Date)
  public readonly updatedAt?: Date;
}
